/* eslint-disable */
/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * MARKETview API
 * OpenAPI spec version: 0.0.1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  AssetClientUserUpdateRequest,
  AssetDto,
  AssetUserAccessDto,
  CountAssetsParams,
  CreateClientAssetBody,
  GetAssetsParams,
  UpdateAsset1Body,
  UpdateAssetBody,
  UserAccessDto,
} from '../schemas';

import { customAxios } from '../../orval-mutator';
import type { ErrorType, BodyType } from '../../orval-mutator';
import { customAxiosResponse } from '../../orval-mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_PRINCIPAL, ROLE_FD_CLIENT_SERVICE, ROLE_FD_ANALYST, ROLE_REPORT_ADMIN**<br /><br />
 */
export const getAssetById = (
  userId: string,
  clientId: number,
  assetId: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<AssetDto>(
    {
      url: `/api/${userId}/clients/${clientId}/assets/${assetId}`,
      method: 'GET',
      signal,
    },
    options
  );
};

export const getGetAssetByIdQueryKey = (
  userId: string,
  clientId: number,
  assetId: number
) => {
  return [`/api/${userId}/clients/${clientId}/assets/${assetId}`] as const;
};

export const getGetAssetByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getAssetById>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  clientId: number,
  assetId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAssetById>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetAssetByIdQueryKey(userId, clientId, assetId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAssetById>>> = ({
    signal,
  }) => getAssetById(userId, clientId, assetId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(userId && clientId && assetId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAssetById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAssetByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAssetById>>
>;
export type GetAssetByIdQueryError = ErrorType<unknown>;

export function useGetAssetById<
  TData = Awaited<ReturnType<typeof getAssetById>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  clientId: number,
  assetId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAssetById>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssetById>>,
          TError,
          Awaited<ReturnType<typeof getAssetById>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAssetById<
  TData = Awaited<ReturnType<typeof getAssetById>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  clientId: number,
  assetId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAssetById>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssetById>>,
          TError,
          Awaited<ReturnType<typeof getAssetById>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAssetById<
  TData = Awaited<ReturnType<typeof getAssetById>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  clientId: number,
  assetId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAssetById>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetAssetById<
  TData = Awaited<ReturnType<typeof getAssetById>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  clientId: number,
  assetId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAssetById>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAssetByIdQueryOptions(
    userId,
    clientId,
    assetId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_PRINCIPAL, ROLE_FD_CLIENT_SERVICE, ROLE_REPORT_ADMIN**<br /><br />
 */
export const updateAsset = (
  userId: string,
  clientId: number,
  assetId: number,
  updateAssetBody?: BodyType<UpdateAssetBody>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  const formData = new FormData();
  if (updateAssetBody?.asset !== undefined) {
    formData.append(`asset`, JSON.stringify(updateAssetBody.asset));
  }
  if (updateAssetBody?.file !== undefined) {
    formData.append(`file`, updateAssetBody.file);
  }

  return customAxios<AssetDto>(
    {
      url: `/api/${userId}/clients/${clientId}/assets/${assetId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData,
      signal,
    },
    options
  );
};

export const getUpdateAssetMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAsset>>,
    TError,
    {
      userId: string;
      clientId: number;
      assetId: number;
      data?: BodyType<UpdateAssetBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateAsset>>,
  TError,
  {
    userId: string;
    clientId: number;
    assetId: number;
    data?: BodyType<UpdateAssetBody>;
  },
  TContext
> => {
  const mutationKey = ['updateAsset'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAsset>>,
    {
      userId: string;
      clientId: number;
      assetId: number;
      data?: BodyType<UpdateAssetBody>;
    }
  > = (props) => {
    const { userId, clientId, assetId, data } = props ?? {};

    return updateAsset(userId, clientId, assetId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateAssetMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateAsset>>
>;
export type UpdateAssetMutationBody = BodyType<UpdateAssetBody> | undefined;
export type UpdateAssetMutationError = ErrorType<unknown>;

export const useUpdateAsset = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateAsset>>,
      TError,
      {
        userId: string;
        clientId: number;
        assetId: number;
        data?: BodyType<UpdateAssetBody>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateAsset>>,
  TError,
  {
    userId: string;
    clientId: number;
    assetId: number;
    data?: BodyType<UpdateAssetBody>;
  },
  TContext
> => {
  return useMutation(getUpdateAssetMutationOptions(options), queryClient);
};
/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_PRINCIPAL, ROLE_FD_CLIENT_SERVICE, ROLE_REPORT_ADMIN**<br /><br />
 */
export const deleteAsset = (
  userId: string,
  clientId: number,
  assetId: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<void>(
    {
      url: `/api/${userId}/clients/${clientId}/assets/${assetId}`,
      method: 'DELETE',
      signal,
    },
    options
  );
};

export const getDeleteAssetMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAsset>>,
    TError,
    { userId: string; clientId: number; assetId: number },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAsset>>,
  TError,
  { userId: string; clientId: number; assetId: number },
  TContext
> => {
  const mutationKey = ['deleteAsset'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAsset>>,
    { userId: string; clientId: number; assetId: number }
  > = (props) => {
    const { userId, clientId, assetId } = props ?? {};

    return deleteAsset(userId, clientId, assetId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAssetMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAsset>>
>;

export type DeleteAssetMutationError = ErrorType<unknown>;

export const useDeleteAsset = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteAsset>>,
      TError,
      { userId: string; clientId: number; assetId: number },
      TContext
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteAsset>>,
  TError,
  { userId: string; clientId: number; assetId: number },
  TContext
> => {
  return useMutation(getDeleteAssetMutationOptions(options), queryClient);
};
/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_PRINCIPAL, ROLE_FD_CLIENT_SERVICE, ROLE_REPORT_ADMIN**<br /><br />
 */
export const updateAsset1 = (
  userId: string,
  clientId: number,
  assetId: number,
  updateAsset1Body?: BodyType<UpdateAsset1Body>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  const formData = new FormData();
  if (updateAsset1Body?.asset !== undefined) {
    formData.append(`asset`, JSON.stringify(updateAsset1Body.asset));
  }
  if (updateAsset1Body?.file !== undefined) {
    formData.append(`file`, updateAsset1Body.file);
  }

  return customAxios<AssetDto>(
    {
      url: `/api/${userId}/clients/${clientId}/assets/${assetId}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData,
      signal,
    },
    options
  );
};

export const getUpdateAsset1MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAsset1>>,
    TError,
    {
      userId: string;
      clientId: number;
      assetId: number;
      data?: BodyType<UpdateAsset1Body>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateAsset1>>,
  TError,
  {
    userId: string;
    clientId: number;
    assetId: number;
    data?: BodyType<UpdateAsset1Body>;
  },
  TContext
> => {
  const mutationKey = ['updateAsset1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAsset1>>,
    {
      userId: string;
      clientId: number;
      assetId: number;
      data?: BodyType<UpdateAsset1Body>;
    }
  > = (props) => {
    const { userId, clientId, assetId, data } = props ?? {};

    return updateAsset1(userId, clientId, assetId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateAsset1MutationResult = NonNullable<
  Awaited<ReturnType<typeof updateAsset1>>
>;
export type UpdateAsset1MutationBody = BodyType<UpdateAsset1Body> | undefined;
export type UpdateAsset1MutationError = ErrorType<unknown>;

export const useUpdateAsset1 = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateAsset1>>,
      TError,
      {
        userId: string;
        clientId: number;
        assetId: number;
        data?: BodyType<UpdateAsset1Body>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateAsset1>>,
  TError,
  {
    userId: string;
    clientId: number;
    assetId: number;
    data?: BodyType<UpdateAsset1Body>;
  },
  TContext
> => {
  return useMutation(getUpdateAsset1MutationOptions(options), queryClient);
};
/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_PRINCIPAL, ROLE_FD_CLIENT_SERVICE, ROLE_FD_ANALYST, ROLE_REPORT_ADMIN**<br /><br />
 */
export const getAssets = (
  userId: string,
  clientId: number,
  params?: GetAssetsParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<AssetUserAccessDto[]>(
    {
      url: `/api/${userId}/clients/${clientId}/assets`,
      method: 'GET',
      params,
      signal,
    },
    options
  );
};

export const getGetAssetsQueryKey = (
  userId: string,
  clientId: number,
  params?: GetAssetsParams
) => {
  return [
    `/api/${userId}/clients/${clientId}/assets`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetAssetsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAssets>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  clientId: number,
  params?: GetAssetsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAssets>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAssetsQueryKey(userId, clientId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAssets>>> = ({
    signal,
  }) => getAssets(userId, clientId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(userId && clientId),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getAssets>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetAssetsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAssets>>
>;
export type GetAssetsQueryError = ErrorType<unknown>;

export function useGetAssets<
  TData = Awaited<ReturnType<typeof getAssets>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  clientId: number,
  params: undefined | GetAssetsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAssets>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssets>>,
          TError,
          Awaited<ReturnType<typeof getAssets>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAssets<
  TData = Awaited<ReturnType<typeof getAssets>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  clientId: number,
  params?: GetAssetsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAssets>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssets>>,
          TError,
          Awaited<ReturnType<typeof getAssets>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAssets<
  TData = Awaited<ReturnType<typeof getAssets>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  clientId: number,
  params?: GetAssetsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAssets>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetAssets<
  TData = Awaited<ReturnType<typeof getAssets>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  clientId: number,
  params?: GetAssetsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAssets>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAssetsQueryOptions(
    userId,
    clientId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_PRINCIPAL, ROLE_FD_CLIENT_SERVICE, ROLE_REPORT_ADMIN**<br /><br />
 */
export const createClientAsset = (
  userId: string,
  clientId: number,
  createClientAssetBody: BodyType<CreateClientAssetBody>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  const formData = new FormData();
  formData.append(`asset`, JSON.stringify(createClientAssetBody.asset));
  formData.append(`file`, createClientAssetBody.file);

  return customAxios<AssetDto>(
    {
      url: `/api/${userId}/clients/${clientId}/assets`,
      method: 'POST',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData,
      signal,
    },
    options
  );
};

export const getCreateClientAssetMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createClientAsset>>,
    TError,
    { userId: string; clientId: number; data: BodyType<CreateClientAssetBody> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createClientAsset>>,
  TError,
  { userId: string; clientId: number; data: BodyType<CreateClientAssetBody> },
  TContext
> => {
  const mutationKey = ['createClientAsset'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createClientAsset>>,
    { userId: string; clientId: number; data: BodyType<CreateClientAssetBody> }
  > = (props) => {
    const { userId, clientId, data } = props ?? {};

    return createClientAsset(userId, clientId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateClientAssetMutationResult = NonNullable<
  Awaited<ReturnType<typeof createClientAsset>>
>;
export type CreateClientAssetMutationBody = BodyType<CreateClientAssetBody>;
export type CreateClientAssetMutationError = ErrorType<unknown>;

export const useCreateClientAsset = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createClientAsset>>,
      TError,
      {
        userId: string;
        clientId: number;
        data: BodyType<CreateClientAssetBody>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createClientAsset>>,
  TError,
  { userId: string; clientId: number; data: BodyType<CreateClientAssetBody> },
  TContext
> => {
  return useMutation(getCreateClientAssetMutationOptions(options), queryClient);
};
/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_PRINCIPAL, ROLE_FD_CLIENT_SERVICE, ROLE_FD_ANALYST, ROLE_REPORT_ADMIN**<br /><br />
 */
export const getAssetClientUsers = (
  userId: string,
  clientId: number,
  assetId: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<UserAccessDto[]>(
    {
      url: `/api/${userId}/clients/${clientId}/assets/${assetId}/users`,
      method: 'GET',
      signal,
    },
    options
  );
};

export const getGetAssetClientUsersQueryKey = (
  userId: string,
  clientId: number,
  assetId: number
) => {
  return [
    `/api/${userId}/clients/${clientId}/assets/${assetId}/users`,
  ] as const;
};

export const getGetAssetClientUsersQueryOptions = <
  TData = Awaited<ReturnType<typeof getAssetClientUsers>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  clientId: number,
  assetId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssetClientUsers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetAssetClientUsersQueryKey(userId, clientId, assetId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAssetClientUsers>>
  > = ({ signal }) =>
    getAssetClientUsers(userId, clientId, assetId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(userId && clientId && assetId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAssetClientUsers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAssetClientUsersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAssetClientUsers>>
>;
export type GetAssetClientUsersQueryError = ErrorType<unknown>;

export function useGetAssetClientUsers<
  TData = Awaited<ReturnType<typeof getAssetClientUsers>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  clientId: number,
  assetId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssetClientUsers>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssetClientUsers>>,
          TError,
          Awaited<ReturnType<typeof getAssetClientUsers>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAssetClientUsers<
  TData = Awaited<ReturnType<typeof getAssetClientUsers>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  clientId: number,
  assetId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssetClientUsers>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssetClientUsers>>,
          TError,
          Awaited<ReturnType<typeof getAssetClientUsers>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAssetClientUsers<
  TData = Awaited<ReturnType<typeof getAssetClientUsers>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  clientId: number,
  assetId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssetClientUsers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetAssetClientUsers<
  TData = Awaited<ReturnType<typeof getAssetClientUsers>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  clientId: number,
  assetId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssetClientUsers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAssetClientUsersQueryOptions(
    userId,
    clientId,
    assetId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_PRINCIPAL, ROLE_FD_CLIENT_SERVICE, ROLE_REPORT_ADMIN**<br /><br />
 */
export const updateAssetClientUserAccess = (
  userId: string,
  clientId: number,
  assetId: number,
  assetClientUserUpdateRequest: BodyType<AssetClientUserUpdateRequest[]>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<UserAccessDto[]>(
    {
      url: `/api/${userId}/clients/${clientId}/assets/${assetId}/users`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: assetClientUserUpdateRequest,
      signal,
    },
    options
  );
};

export const getUpdateAssetClientUserAccessMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAssetClientUserAccess>>,
    TError,
    {
      userId: string;
      clientId: number;
      assetId: number;
      data: BodyType<AssetClientUserUpdateRequest[]>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateAssetClientUserAccess>>,
  TError,
  {
    userId: string;
    clientId: number;
    assetId: number;
    data: BodyType<AssetClientUserUpdateRequest[]>;
  },
  TContext
> => {
  const mutationKey = ['updateAssetClientUserAccess'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAssetClientUserAccess>>,
    {
      userId: string;
      clientId: number;
      assetId: number;
      data: BodyType<AssetClientUserUpdateRequest[]>;
    }
  > = (props) => {
    const { userId, clientId, assetId, data } = props ?? {};

    return updateAssetClientUserAccess(
      userId,
      clientId,
      assetId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateAssetClientUserAccessMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateAssetClientUserAccess>>
>;
export type UpdateAssetClientUserAccessMutationBody = BodyType<
  AssetClientUserUpdateRequest[]
>;
export type UpdateAssetClientUserAccessMutationError = ErrorType<unknown>;

export const useUpdateAssetClientUserAccess = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateAssetClientUserAccess>>,
      TError,
      {
        userId: string;
        clientId: number;
        assetId: number;
        data: BodyType<AssetClientUserUpdateRequest[]>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateAssetClientUserAccess>>,
  TError,
  {
    userId: string;
    clientId: number;
    assetId: number;
    data: BodyType<AssetClientUserUpdateRequest[]>;
  },
  TContext
> => {
  return useMutation(
    getUpdateAssetClientUserAccessMutationOptions(options),
    queryClient
  );
};
/**
 * Authorities: **Any authenticated role**
 */
export const downloadAsset = (
  userId: string,
  clientId: number,
  assetId: number,
  options?: SecondParameter<typeof customAxiosResponse>,
  signal?: AbortSignal
) => {
  return customAxiosResponse<Blob>(
    {
      url: `/api/${userId}/clients/${clientId}/assets/${assetId}/download`,
      method: 'GET',
      signal,
    },
    options
  );
};

export const getDownloadAssetQueryKey = (
  userId: string,
  clientId: number,
  assetId: number
) => {
  return [
    `/api/${userId}/clients/${clientId}/assets/${assetId}/download`,
  ] as const;
};

export const getDownloadAssetQueryOptions = <
  TData = Awaited<ReturnType<typeof downloadAsset>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  clientId: number,
  assetId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof downloadAsset>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosResponse>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getDownloadAssetQueryKey(userId, clientId, assetId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadAsset>>> = ({
    signal,
  }) => downloadAsset(userId, clientId, assetId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(userId && clientId && assetId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof downloadAsset>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DownloadAssetQueryResult = NonNullable<
  Awaited<ReturnType<typeof downloadAsset>>
>;
export type DownloadAssetQueryError = ErrorType<unknown>;

export function useDownloadAsset<
  TData = Awaited<ReturnType<typeof downloadAsset>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  clientId: number,
  assetId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof downloadAsset>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadAsset>>,
          TError,
          Awaited<ReturnType<typeof downloadAsset>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosResponse>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDownloadAsset<
  TData = Awaited<ReturnType<typeof downloadAsset>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  clientId: number,
  assetId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof downloadAsset>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadAsset>>,
          TError,
          Awaited<ReturnType<typeof downloadAsset>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosResponse>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDownloadAsset<
  TData = Awaited<ReturnType<typeof downloadAsset>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  clientId: number,
  assetId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof downloadAsset>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosResponse>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useDownloadAsset<
  TData = Awaited<ReturnType<typeof downloadAsset>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  clientId: number,
  assetId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof downloadAsset>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosResponse>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getDownloadAssetQueryOptions(
    userId,
    clientId,
    assetId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_PRINCIPAL, ROLE_FD_CLIENT_SERVICE, ROLE_FD_ANALYST, ROLE_REPORT_ADMIN**<br /><br />
 */
export const countAssets = (
  userId: string,
  clientId: number,
  params?: CountAssetsParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<number>(
    {
      url: `/api/${userId}/clients/${clientId}/assets/count`,
      method: 'GET',
      params,
      signal,
    },
    options
  );
};

export const getCountAssetsQueryKey = (
  userId: string,
  clientId: number,
  params?: CountAssetsParams
) => {
  return [
    `/api/${userId}/clients/${clientId}/assets/count`,
    ...(params ? [params] : []),
  ] as const;
};

export const getCountAssetsQueryOptions = <
  TData = Awaited<ReturnType<typeof countAssets>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  clientId: number,
  params?: CountAssetsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof countAssets>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getCountAssetsQueryKey(userId, clientId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof countAssets>>> = ({
    signal,
  }) => countAssets(userId, clientId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(userId && clientId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof countAssets>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CountAssetsQueryResult = NonNullable<
  Awaited<ReturnType<typeof countAssets>>
>;
export type CountAssetsQueryError = ErrorType<unknown>;

export function useCountAssets<
  TData = Awaited<ReturnType<typeof countAssets>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  clientId: number,
  params: undefined | CountAssetsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof countAssets>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof countAssets>>,
          TError,
          Awaited<ReturnType<typeof countAssets>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCountAssets<
  TData = Awaited<ReturnType<typeof countAssets>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  clientId: number,
  params?: CountAssetsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof countAssets>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof countAssets>>,
          TError,
          Awaited<ReturnType<typeof countAssets>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCountAssets<
  TData = Awaited<ReturnType<typeof countAssets>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  clientId: number,
  params?: CountAssetsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof countAssets>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useCountAssets<
  TData = Awaited<ReturnType<typeof countAssets>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  clientId: number,
  params?: CountAssetsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof countAssets>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getCountAssetsQueryOptions(
    userId,
    clientId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}
